import {getRsvpButtonMargin} from '../../../selectors/single-settings'
import {AppProps} from '../../app/interfaces'
import {withMargin} from '../../hoc/with-margin'
import {RsvpButton as RsvpButtonPresentation} from './rsvp-button'

const getMargin = ({state}: AppProps) => getRsvpButtonMargin(state)

export const RsvpButton = withMargin(RsvpButtonPresentation, getMargin)
